/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Settings_DisplayInputs */

const en_ui_settings_display = /** @type {(inputs: Ui_Settings_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display`)
};

const de_ui_settings_display = /** @type {(inputs: Ui_Settings_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzeige`)
};

/**
* | output |
* | --- |
* | "Display" |
*
* @param {Ui_Settings_DisplayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_settings_display = /** @type {((inputs?: Ui_Settings_DisplayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Settings_DisplayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_settings_display(inputs)
	return de_ui_settings_display(inputs)
});